import { Box, Typography } from '@mui/material';
import WrapperPieComponent from '../charts/PieComponent/wrapper-pie-component';
import CustomSectionWrapper from '@/DesignSystem/wrappers/CustomSectionWrapper';

const options = {
    type: 'pie',
    options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { display: false },
            title: { display: true, text: 'Distribución de minutos jugados' },
        },
    },
};

const PieChartCard = ({ title, labels, colors, data }) => (
    <Box
        sx={{
            p: 2,
            boxShadow: '0 2px 8px rgba(0,0,0,.1)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        }}
        width="100%"
    >
        <Typography
            sx={{ marginBottom: '8px', fontSize: '16px' }}
            fontWeight={500}
            variant="h2"
            textTransform={'uppercase'}
        >
            {title}
        </Typography>
        <Box direction="row" spacing={1} display={'flex'} justifyContent="center" gap={1}>
            {labels.map((label, index) => (
                <Typography
                    key={label}
                    sx={{ backgroundColor: colors[index], color: '#fff' }}
                    py={0.5}
                    fontSize={12}
                    borderRadius={1}
                    width={55}
                    textAlign={'center'}
                    variant="h3"
                >
                    {label}
                </Typography>
            ))}
        </Box>
        <Box width={300} height={300}>
            <WrapperPieComponent data={data} options={options} />
        </Box>
    </Box>
);

const MinutesActionsMatchesTotalPlayerComponent = ({ partidos = [], isModal = true }) => {
    const partidos90Minutos = partidos.filter((p) => p.minutes >= 90).length;
    const partidos60Minutos = partidos.filter((p) => p.minutes >= 60 && p.minutes < 90).length;
    const partidos45Minutos = partidos.filter((p) => p.minutes >= 45 && p.minutes < 60).length;
    const partidosMenos45Minutos = partidos.filter((p) => p.minutes > 0 && p.minutes < 45).length;
    const partidosNoJugo = partidos.filter((p) => !p.minutes || p.minutes === 0).length;

    const partidos60MinutosJugados = partidos.filter((p) => p.minutes >= 60).length;
    const partidos60MinutosNoJugados = partidos.length - partidos60MinutosJugados;

    const azul = 'rgba(25, 118, 210, 0.7)';
    const verde = 'rgba(75, 192, 75, 0.7)';
    const naranja = 'rgba(255, 165, 0, 0.7)'; // Naranja
    const rojo = 'rgba(255, 99, 132, 0.7)'; // Rojo
    const negro = 'rgba(0, 0, 0, .7)';

    const labelsMinutes = ['90+ mins', '60+ -90', '45+ -60', '45- mins', '0 mins'];
    const colorsMinutes = [azul, verde, naranja, rojo, negro];

    const labelsMatches = ['60+ mins', '59- mins'];
    const colorsMatches = [azul, rojo];

    const chartDataPartidos = {
        datasets: [
            {
                label: 'Partidos disputados',
                data: [
                    partidos90Minutos,
                    partidos60Minutos,
                    partidos45Minutos,
                    partidosMenos45Minutos,
                    partidosNoJugo,
                ],
                backgroundColor: colorsMinutes,
                borderColor: 'rgba(0, 0, 0, 0.3)',
                borderWidth: 1,
            },
        ],
    };

    const chartDataPartidos60Minutos = {
        datasets: [
            {
                label: 'Partidos disputados',
                data: [partidos60MinutosJugados, partidos60MinutosNoJugados],
                backgroundColor: colorsMatches,
                borderColor: 'rgba(0, 0, 0, 0.3)',
                borderWidth: 1,
            },
        ],
    };

    return (
        <>
            <CustomSectionWrapper color="accent2" title="Minutos disputados en partidos">
                <PieChartCard labels={labelsMinutes} colors={colorsMinutes} data={chartDataPartidos} />
            </CustomSectionWrapper>
            <CustomSectionWrapper color="accent3" title="Disputó 60 minutos o más">
                <PieChartCard
                    labels={labelsMatches}
                    colors={colorsMatches}
                    data={chartDataPartidos60Minutos}
                />
            </CustomSectionWrapper>
        </>
    );
};

export default MinutesActionsMatchesTotalPlayerComponent;
